const es = {
    translation: {
        button: {
            cancel: 'CANCELAR',
            close: 'CERRAR',
            requestIncrease: 'SOLICITAR AUMENTO'
        },
        cliBusinessError: {
            subTitle: 'Recibirá una carta dentro de 7 a 10 días hábiles en la que se le explicará la razón de nuestra decisión.',
            title: 'No podemos aumentar su límite de crédito en este momento'
        },
        cliPartialSuccess: {
            subTitle: 'No podemos otorgarle el monto total que ha solicitado. Sin embargo, podemos aumentar su límite de crédito. Recibirá una carta dentro de 7 a 10 días hábiles en la que se le explicará la razón de nuestra decisión.'
        },
        cliPendingReferral: {
            subTitle: 'Estamos revisando su solicitud. Recibirá una carta dentro de 7 a 10 días hábiles con nuestra decisión sobre su solicitud.',
            title: 'Su solicitud de límite de crédito está pendiente.'
        },
        cliSuccess: {
            newLimit: 'NUEVO LÍMITE DE CRÉDITO',
            subText: 'Su límite de crédito está disponible para uso inmediato.',
            subTitle: 'Su solicitud de aumento del límite de crédito se aprobó por lo siguiente:',
            title: 'Hemos aumentado su límite de crédito'
        },
        errorMessages: {
            unableToProcessRequest: 'Lamentablemente no podemos procesar su solicitud en este momento. Por favor intente nuevamente más tarde.'
        },
        mocks: {
            accountEnding: 'Cuenta que termina en {{accountLast4}}'
        },
        modal: {
            annualNetIncome: 'Ingresos Netos Anuales',
            annualNetIncomeHelperText: 'Incluya ingresos de fuentes después de impuestos',
            annualNetIncomeInputErrorText: 'Ingrese el monto de sus ingresos, incluyendo fuentes después de impuestos',
            cliRequest: 'Solicitar un aumento del límite de crédito',
            creditLimit: `{{creditLimit}}`,
            currentCreditLimit: 'LÍMITE DE CRÉDITO ACTUAL',
            desiredIncreaseInputErrorText: 'Ingrese el límite de crédito que desea solicitar',
            desiredLimit: 'Límite Deseado',
            desiredLimitHelperText: 'Ingrese el límite de crédito total que desea solicitar',
            increaseLimitByMore: 'El nuevo límite deseado debe ser al menos de $50 más que el límite de crédito actual'
        },
        text: {
            legalText: `Sus “Ingresos Netos” incluyen lo que gana o lo que razonablemente espera ganar por su empleo,
       inversiones, jubilación, beneficios del seguro social y asistencia pública. También puede incluir el dinero
       que otra persona deposita regularmente en su cuenta (individual o conjunta) y el monto que tiene disponible
       para gastar de sus activos. Si usted tiene 21 años o más, también podrá incluir el monto de los ingresos de
       alguna otra persona que se use periódicamente para pagar sus gastos. No es necesario incluir la cuota alimentaria,
       la manutención de menores ni los ingresos de manutención por separación judicial, salvo que se dependa de estos
       para el crédito. Residentes de Wisconsin (WI) Únicamente: Si esta es una cuenta individual, por favor también
       incluya los ingresos de su cónyuge.`
        }
    }
};
export default es;
